<template>
    <div class="single-card">
        <h2>Complete seu cadastro</h2>
        <form @submit.prevent="save">
            <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
                <input class="form__input" v-model.trim="$v.name.$model"/>
                <label class="form__label" :class="{'up': $v.name.$model }">Nome</label>
                <div class="error" v-if="!$v.name.required">Nome é obrigatório</div>
                <div class="error" v-if="!$v.name.minLength">Nome deve conter pelo menos {{$v.name.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.companyname.$error }">
                <input class="form__input" value="" v-model.trim="$v.companyname.$model"/>
                <label class="form__label" :class="{'up': $v.companyname.$model }">Empresa (nome fantasia)</label>
                <div class="error" v-if="!$v.companyname.required">Empresa é obrigatório</div>
                <div class="error" v-if="!$v.companyname.minLength">Empresa deve conter pelo menos {{$v.companyname.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.tradingname.$error }">
                <input class="form__input" value="" v-model.trim="$v.tradingname.$model"/>
                <label class="form__label" :class="{'up': $v.tradingname.$model }">Razão social</label>
                <div class="error" v-if="!$v.tradingname.required">Razão social é obrigatório</div>
                <div class="error" v-if="!$v.tradingname.minLength">Razão social deve conter pelo menos {{$v.tradingname.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.document.$error }">
                <input class="form__input" value="" v-model.trim="$v.document.$model" v-mask="'##.###.###/####-##'" />
                <label class="form__label" :class="{'up': $v.document.$model }">CNPJ</label>

                <div class="error" v-if="!$v.document.required">CNPJ é obrigatório</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.phone.$error }">
                <input class="form__input" value="" v-model.trim="$v.phone.$model" v-mask="['(##) ####-####', '(##) #####-####']" />
                <label class="form__label" :class="{'up': $v.phone.$model }">Telefone</label>
                <div class="error" v-if="!$v.phone.required">Telefone é obrigatório</div>
            </div>
    
            <button class="button" type="submit" :disabled="submitStatus === 'PENDING'">Salvar</button>
            <!-- <p class="typo__p" v-if="submitStatus === 'OK'"></p> -->
            <p class="typo__p" v-if="submitStatus === 'ERROR'">Por favor, preencha todos os campos corretamente.</p>
            <p class="typo__p" v-if="submitStatus === 'PENDING'">Processando...</p>
        </form>
    </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
export default {
    name: "Complete",
    components: {
    },
    data(){
        return {
            submitStatus: null,
            email: '',
            name: '',
            companyname: '',
            tradingname: '',
            document: '',
            phone: ''
        }
    },
  
    validations: {
        name: {
            required,
            minLength: minLength(4)
        },
        companyname: {
            required,
            minLength: minLength(4)
        },
        tradingname: {
            required,
            minLength: minLength(6)
        },
        document: {
            required,
            minLength: minLength(17)
        },
        phone: {
            required,
            minLength: minLength(8)
        }
    },
    props: {
        company: {
            type: Object
        }
    },
    mounted(){
        this.loadSnap()
        console.log(this.$user)

    },
    methods: {
        
        loadSnap(){
            let keys = ['name', 'email', 'companyname', 'tradingname', 'document', 'phone']
            keys.forEach((key) => {
                this[key] = this.company[key]
            })
        },
        submit() {
            console.log('submit!')
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
            // do your submit logic here
            this.submitStatus = 'PENDING'
            setTimeout(() => {
              this.submitStatus = 'OK'
              this.save()
            }, 500)
            }
        },
        save(){
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
                let toAdd = false 
                let company = this.company
                if(!company)
                    company = {}
                if(!this.company.hasOwnProperty('docId'))
                    toAdd= true
                company.uid         = this.$user.uid
                company.email       = this.email            
                company.name        = this.name
                company.companyname = this.companyname
                company.tradingname = this.tradingname
                company.document    = this.document
                company.phone       = this.phone
                company.lastUpdate  = this.$moment().format('X')
                company.type        = 1

                if(!company.hasOwnProperty('email') || !company.email)
                    company.email = this.$root.user.email
                if(toAdd){
                    this.$db.collection('companies').add(company).then((result) => {
                        if(result)
                        this.$root.updated = false
                        this.$router.replace('app')
                    },
                    (err) => {
                        this.$root.updated = false
                        alert('Erro ao salvar: ' + err)
                    });
                }
                else{
                    this.$db.collection("companies").doc(this.company.docId).set(company).then((result) => {
                        if(result)
                        this.$root.updated = false
                        this.$router.replace('app')
                    },
                    (err) => {
                        this.$root.updated = false
                        alert('Erro ao salvar: ' + err)
                    });
                }
            }
        }
    }
} 
</script>